const openingHours = [
  { day: "Monday",    hours: "07:00am to 08:00pm" },
  { day: "Tuesday",   hours: "07:00am to 08:00pm" },
  { day: "Wednesday", hours: "07:00am to 08:00pm" },
  { day: "Thursday",  hours: "07:00am to 08:00pm" },
  { day: "Friday",    hours: "07:00am to 08:00pm" },
  { day: "Saturday",  hours: "07:00am to 08:00pm" },
  { day: "Sunday",    hours: "08:00am to 06:00pm" },
];

export default function ContactInfo() {
  return (
    <section className="py-20 bg-cl-dark">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-cl-lime/20 border-2 border-cl-lime/30 rounded-full px-4 py-1.5 mb-4">
            <span className="text-cl-lime text-xs font-black uppercase tracking-widest">Contact Us</span>
          </div>
          <h2 className="font-black text-white leading-tight" style={{ fontSize: "clamp(2rem, 4vw, 3rem)" }}>
            Ways you can contact us
          </h2>
        </div>

        {/* 3 cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">

          {/* Let's chat */}
          <div className="bg-white/5 border-2 border-white/10 rounded-3xl p-7 flex flex-col gap-4">
            <div className="flex items-center gap-4">
              <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-cl-lime thick-border flex-shrink-0">
                <i className="ri-whatsapp-line text-cl-dark text-2xl"></i>
              </div>
              <h3 className="text-white font-black text-lg">WhatsApp &amp; Callback</h3>
            </div>
            <p className="text-white/65 text-sm leading-relaxed font-semibold">
              Message us on WhatsApp during our opening hours and we&apos;ll get back to you promptly.
            </p>
            <p className="text-white/65 text-sm leading-relaxed font-semibold">
              As well as WhatsApp, we provide a callback service at a time to suit you — no call queues, no waiting around.
            </p>
            <div className="mt-auto flex flex-col gap-3">
              <a
                href="https://wa.me/443335775445"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="inline-flex items-center gap-2 bg-cl-lime text-cl-dark font-black text-sm px-5 py-3 rounded-xl cartoon-btn whitespace-nowrap w-fit cursor-pointer"
              >
                <i className="ri-whatsapp-line"></i>
                WhatsApp Us
              </a>
              <a
                href="tel:03335775445"
                className="inline-flex items-center gap-2 bg-cl-green text-white font-black text-sm px-5 py-3 rounded-xl cartoon-btn-green whitespace-nowrap w-fit cursor-pointer"
              >
                <i className="ri-phone-fill"></i>
                03335 775445
              </a>
            </div>
          </div>

          {/* Our location */}
          <div className="bg-white/5 border-2 border-white/10 rounded-3xl p-7 flex flex-col gap-4">
            <div className="flex items-center gap-4">
              <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-cl-lime thick-border flex-shrink-0">
                <i className="ri-map-pin-2-line text-cl-dark text-2xl"></i>
              </div>
              <h3 className="text-white font-black text-lg">Our location</h3>
            </div>
            <p className="text-white/65 text-sm leading-relaxed font-semibold">
              We cover multiple regions using our own fleet and directly employed staff — every one of them DBS checked and fully vetted. Contact us if your area isn&apos;t covered.
            </p>
            <p className="text-white/65 text-sm leading-relaxed font-semibold">
              Our head office is in Worcestershire.
            </p>
            <div className="mt-auto bg-white/5 border-2 border-white/10 rounded-2xl px-4 py-4">
              <p className="text-cl-lime font-black text-sm mb-1">Cleario</p>
              <p className="text-white/60 text-sm font-semibold leading-relaxed">
                Unit 4, Crown Farm<br />
                Crown Lane, Wychbold<br />
                Droitwich<br />
                WR9 0BX
              </p>
            </div>
          </div>

          {/* Opening times */}
          <div className="bg-white/5 border-2 border-white/10 rounded-3xl p-7 flex flex-col gap-4">
            <div className="flex items-center gap-4">
              <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-cl-lime thick-border flex-shrink-0">
                <i className="ri-time-line text-cl-dark text-2xl"></i>
              </div>
              <h3 className="text-white font-black text-lg">Opening times</h3>
            </div>
            <div className="flex flex-col gap-2 mt-1">
              {openingHours.map((item) => (
                <div key={item.day} className="flex items-center justify-between gap-2">
                  <span className="text-white/55 text-sm font-semibold w-28 flex-shrink-0">{item.day}:</span>
                  <span className="text-white text-sm font-black">{item.hours}</span>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
